import Core from "@/modules/core/service/Core";
import Contract from "@/modules/msd/company/contract/service/Contract";

export default  {
    props: {
        contract: {

        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        selected: {

        }
    },

    data: () => ({
        edit: false
    }),

    computed: {
        isAutorenew () {
            return this.contract.tocRewal;
        },
    },

    methods: {
        onRenew () {
            Core.message.confirm(
                this,
                this.$t("contract.renew.title"),
                this.$t("contract.renew.text.contract"),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Contract.renew(this.contract.id).then (() => {
                            this.$emit("renew", this.contract);
                        })
                    }
                })
        },

        onSelected () {
            if (!this.contract.active) {
                return;
            }
            Core.fire.selected(this, this.contract);
        },

        onEdit () {
            this.edit = true;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        },

        toHtml (text) {
            return Core.format.html(text);
        },

        money (value) {
            return Core.format.money(value);
        },

        date (value) {
            return Core.format.date.sdisplay(value);
        },
    }
}